var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailFillBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8 4H3.2C2.54 4 2 4.54 2 5.2V17.6C2 18.92 3.08 20 4.4 20H19.6C20.92 20 22 18.92 22 17.6V5.2C22 4.54 21.46 4 20.8 4ZM5.6509 6.30078C5.23162 5.9413 4.60031 5.98979 4.24084 6.40907C3.88137 6.82836 3.92985 7.45966 4.34914 7.81913L11.2192 13.7092C11.4649 13.9198 11.7556 13.995 12 13.995C12.2444 13.995 12.5352 13.9197 12.7809 13.7091L19.6509 7.81913C20.0702 7.45966 20.1187 6.82836 19.7592 6.40907C19.3997 5.98979 18.7684 5.9413 18.3491 6.30078L12 11.7442L5.6509 6.30078Z",
    fill: "#212D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFillBlack);
export default __webpack_public_path__ + "static/media/mail-fill-black.d13fcfe8a63ff6b80864eb8e3249d482.svg";
export { ForwardRef as ReactComponent };